export const defaultBenchmarks = [
  {
    label: "DAX",
    notation: 20735,
    color: "#323390",
    active: false
  },
  {
    label: "MDAX",
    notation: 323547,
    color: "#0073ba",
    active: false
  },
  {
    label: "SDAX",
    notation: 324724,
    color: "#00afed",
    active: false
  },
  {
    label: "IBEX_35",
    notation: 324911,
    color: "#912a8e",
    active: false
  },
  {
    label: "Euro Stoxx 50",
    notation: 193736,
    color: "#00a99c",
    active: false
  }
];
